import * as React from "react";
import { LoginData, useLoginData } from "@brite-inc/ui-hooks/dist/loginData";
import { getLocalStorage } from "@brite-inc/ui-hooks/dist/localStorage";
import { ITheme } from "@brite-inc/ui-remote-transport-lms";
import { IUseThemeResult, useTheme } from "./";

interface IProps {
    children: ({
        selectedTheme,
        setTheme,
    }: IUseThemeResult) => React.ReactElement;
    themes: ITheme[];
}

export const ThemeInitializer = ({
    themes,
    children,
}: IProps): React.ReactElement | null => {
    const { loginData } = useLoginData();
    const { selectedTheme, setTheme } = useTheme({
        themes: themes,
        initialTheme: themes[0],
    });

    React.useEffect(() => {
        const themePreferences = LoginData.themesFromStorage(getLocalStorage());

        if (themes) {
            const selectedTheme =
                themes.find(
                    (t) => t.name === themePreferences?.selectedThemeName,
                ) || themes[0];

            if (!selectedTheme) {
                return;
            }

            setTheme(selectedTheme);
        }
    }, [loginData]);

    return children({ selectedTheme, setTheme });
};
